import { type UseModalState } from "@clipboard-health/ui-components";
import { type BookabilityStatusItem } from "@src/appV2/OpenShifts/ShiftAction";
import { hasInstantBookCriteriaUnmet } from "@src/appV2/OpenShifts/ShiftAction/hasInstantBookCriteriaUnmet";
import { differenceInMinutes, parseISO } from "date-fns";

import { type ComputedArrivalData } from "../../ArrivalTime/computeArrivalData";
import { useIsArrivalTimeEligible } from "../../ArrivalTime/useIsArrivalTimeEligible";
import { type ModalShiftData } from "../types";
import { RegularShiftBookedBottomSheetContainer } from "./RegularShiftBookedBottomSheetContainer";
import { ShortLeadTimeShiftBookedBottomSheetContainer } from "./ShortLeadTimeShiftBookedBottomSheetContainer";

interface ShiftBookedBottomSheetContainerProps {
  modalState: UseModalState;
  shift: ModalShiftData;
  bookabilityStatus?: BookabilityStatusItem;
  computedArrivalData?: ComputedArrivalData;
}

export function ShiftBookedBottomSheetContainer(props: ShiftBookedBottomSheetContainerProps) {
  const { modalState, shift, bookabilityStatus, computedArrivalData } = props;

  const isShortLeadTime = useIsArrivalTimeEligible({
    shiftStartIso: shift.attributes.start,
    workplaceType: shift.workplace?.attributes?.type,
    isInstantBook: !hasInstantBookCriteriaUnmet(bookabilityStatus),
  });

  const shouldAlreadyLeave =
    computedArrivalData &&
    (parseISO(shift.attributes.start) < computedArrivalData.targetArrivalTime ||
      differenceInMinutes(computedArrivalData.departureTime, new Date()) <=
        computedArrivalData.gracePeriodInMinutes);

  return isShortLeadTime && shouldAlreadyLeave ? (
    <ShortLeadTimeShiftBookedBottomSheetContainer modalState={modalState} shift={shift} />
  ) : (
    <RegularShiftBookedBottomSheetContainer modalState={modalState} shift={shift} />
  );
}
